import React from 'react'
import RecordingDetectionsSVG from '../lib/recordingDetectionsSVG'

export default function RecordingSVG({ record }) {
	return (
		<div
			dangerouslySetInnerHTML={{
				__html: new RecordingDetectionsSVG(record).build()
			}}
		/>
	)
};